export function usePermission() {
  const { user } = useUserSession()

  const permissions = computed(() => user.value?.permissions ?? [])

  function can(code: string): boolean {
    return permissions.value.includes(code)
  }

  function canAny(codes: string[]): boolean {
    return codes.some(code => can(code))
  }

  const isSuperAdmin = computed(() => user.value?.role === 'SUPER_ADMIN')

  return {
    permissions,
    can,
    canAny,
    isSuperAdmin,
  }
}
